<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>

        <div class="card_table">
            <el-card shadow="never"
                     v-for="(item, index) in tableData"
                     :key="index"
                     class="card_item">
                <!--
                <div class="btn_box">
                    <div class="icon" @click="delRow(index)">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="删除"
                                    placement="top">
                            <i class="el-icon-delete"></i>
                        </el-tooltip>
                    </div>
                </div>-->
                <div class="img_box" @click="lookRow(item)">
                    <img :src="showImgUrl(item)">
                </div>
                <div @click="lookRow(item)" class="title">{{item.title}}</div>
                <div @click="lookRow(item)" class="text">{{item.brief}}</div>
                <div @click="lookRow(item)" class="date">{{item.update_time}}</div>
            </el-card>
            <!--
            <el-card shadow="never" class="card_item">
                <div class="add_box" @click="openDialog()">
                    <i class="el-icon-plus"></i>
                </div>
            </el-card>-->
        </div>
<!--
        <div class="bottom_btn">
            <el-button class="text_bottom_btn" @click="submitText" type="primary">提交</el-button>
            <el-button class="text_bottom_btn" @click="goBack">取消</el-button>
        </div>-->

        <div class="html_box" v-if="showHtmlLook">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="showHtmlLook = false">
                    <i class="el-icon-back"></i>
                    返回图文列表
                </div>
            </div>
            <div class="header">
                <div class="title">
                    {{look_row.title}}
                </div>
                <div class="author">
                    {{look_row.create_time}} {{look_row.create_user.name}}
                </div>
            </div>
            <div class="main" v-html="look_row.content"></div>
        </div>

        <div class="dialog_all" v-show="dialogSelectText">
            <div class="header">{{dialog_title}}</div>
            <div class="text_box">
                <div class="search_item">
                    <div class="title">标题：</div>
                    <div class="input_box">
                        <el-input v-model="search_name"
                                  @change="getTableDataAll()"
                                  size="small"
                                  class="width_400">
                            <el-button slot="append"
                                       @click="getTableDataAll()"
                                       icon="el-icon-search"></el-button>
                        </el-input>
                    </div>
                </div>
                <div class="card_table">
                    <el-card shadow="never"
                             v-for="(item, index) in tableDataSelect"
                             :key="index"
                             class="card_item">
                        <div class="btn_box">
                            <div class="icon"
                                 :class="select_text.paper_id == item.paper_id?'actived_icon':''"
                                 @click="selectRow(item)">
                                <el-tooltip class="item"
                                            effect="dark"
                                            content="选择"
                                            placement="top">
                                    <i class="el-icon-check"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="img_box" @click="lookRow(item)">
                            <img :src="showImgUrl(item)" alt="">
                        </div>
                        <div @click="lookRow(item)" class="title">
                            {{item.title}}
                        </div>
                        <div @click="lookRow(item)" class="text">
                            {{item.brief}}
                        </div>
                        <div @click="lookRow(item)" class="date">
                            {{item.update_time}}
                        </div>
                    </el-card>
                </div>
            </div>
            <div class="bottom_btn">
                <el-button @click="closeDia()">取 消</el-button>
                <el-button type="primary"
                           :disabled="submit_disable_dia"
                           @click="submitSelect()">确 定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {clone} from "../../global/utils";
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "imageText",
        data() {
            return {
                viewTitle: '图文列表',
                dialog_title: '选择图文',

                tableData: [],

                showHtmlLook: false,
                look_row: {},

                dialogSelectText: false,
                search_name: '',
                tableDataSelect: [],
                select_text: {},
            }
        },
        computed: {
            ...mapState('learnData', {
                textData: 'textData'
            }),
            submit_disable_dia() {
                return JSON.stringify(this.select_text) === '{}'
            },
        },
        mounted() {
            if (this.textData) {
                this.viewTitle = this.textData.item_type + '列表';
                this.dialog_title = '选择' + this.textData.item_type;
                if (this.textData.cycle_items && this.textData.cycle_items.length > 0) {
                    this.tableData = clone(this.textData.cycle_items)
                }
            }
        },
        methods: {
            showImgUrl(item) {
                if (item.cover.indexOf('http') > -1) {
                    return item.cover
                }
                return item.pre_file + item.cover
            },
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            delRow(index) {
                this.tableData.splice(index, 1)
            },
            lookRow(row) {
                this.look_row = row;
                this.showHtmlLook = true
            },

            openDialog() {
                this.dialogSelectText = true;
                this.tableDataSelect = [];
                this.select_text = [];
                this.search_name = '';
            },
            getTableDataAll(val = 1) {
                this.select_text = {};
                if (!this.search_name) {
                    this.tableDataSelect = [];
                    return
                }
                let params = {
                    page: val,
                    page_size: 100,
                    cates: '',
                    ill_id: '',
                    ill_cycle_id: '',
                    name: this.search_name,
                };
                this.httpGet('/paper/list', params).then(res => {
                    this.tableDataSelect = res.data.papers;
                })
            },
            selectRow(row) {
                this.select_text = row;
            },
            closeDia() {
                this.dialogSelectText = false;
            },
            submitSelect() {
                let hasList = this.tableData.filter(
                    v => v.paper_id == this.select_text.paper_id);
                if (hasList && hasList.length > 0) {
                    this.$message.warning('该图文已选择！')
                } else {
                    this.tableData.push(this.select_text);
                    this.dialogSelectText = false;
                }
            },

            submitText() {
                let ids = [];
                this.tableData.forEach(v => {
                    ids.push(v.paper_id)
                });
                let params = {
                    ill_id: this.textData.ill_id,
                    item_type: this.textData.item_type,
                    ill_cycle_id: this.textData.ill_cycle_id,
                    cycle_item_ids: ids
                };
                this.httpPost('/push_cycle_config', params).then(res => {
                    this.$message.success('图文修改成功！');
                    this.goBack()
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246,247,248);
    $btn_border: rgb(246,247,248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        position: relative;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            z-index: 1;
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .card_table {
            width: 100%;
            height: calc(100% - 50px);
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            padding: 5px;
            z-index: 1;
            .card_item {
                width: 300px;
                height: 300px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                &:hover {
                    .btn_box {
                        display: flex;
                    }
                }
                .btn_box {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    z-index: 9;
                    cursor: pointer;
                    display: none;
                    .icon {
                        width: 35px;
                        height: 35px;
                        background: #fff;
                        border-radius: 50%;
                        line-height: 35px;
                        text-align: center;
                        margin-right: 5px;
                        i {
                            font-size: 1.123rem;
                        }
                    }
                }
                .img_box {
                    width: 300px;
                    height: 180px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .title {
                    line-height: 30px;
                    padding: 0 10px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    line-height: 30px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    line-height: 30px;
                }

                .add_box {
                    width: 300px;
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    font-size: 6rem;
                    color: #8c939d;
                    cursor: pointer;
                    &:hover {
                        box-sizing: border-box;
                        border: 1px dashed #409eff;
                    }
                }
            }
        }
        .bottom_btn {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 50px;
            line-height: 50px;
            padding-right: 50px;
            background: #fff;
            text-align: right;
            z-index: 1;
            .text_bottom_btn {
                margin-left: 30px;
            }
        }

        .html_box {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 99;
            background: $view_background;
            .btn_box {
                width: 110px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
            .header {
                font-size: 2rem;
                line-height: 50px;
                margin-bottom: 10px;
                .title {
                    font-size: 2rem;
                    line-height: 50px;
                }
                .author {
                    margin-left: 20px;
                    font-size: .75rem;
                    color: #9B9B9B;
                    line-height: 30px;
                    padding-top: 20px;
                }
            }
            .main {
                box-sizing: border-box;
            }
        }


        .dialog_all {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: flex;
            flex-flow: column;
            z-index: 3;
            background: #fff;
            .header {
                flex: 0 0 50px;
                width: 100%;
                box-sizing: border-box;
            }
            .bottom_btn {
                flex: 0 0 50px;
                width: 100%;
                box-sizing: border-box;
                border-top: 1px solid #ddd;
            }
            .text_box {
                flex: 1;
                width: 100%;
                padding: 5px;
                box-sizing: border-box;
                height: calc(100% - 100px);
                .search_item {
                    line-height: 40px;
                    height: 40px;
                    display: flex;
                    padding-left: 10px;
                }
                .card_table {
                    height: calc(100% - 80px);
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    overflow: hidden;
                    overflow-y: auto;
                    box-sizing: border-box;
                    .card_item {
                        width: 300px;
                        height: 300px;
                        position: relative;
                        z-index: 1;
                        margin: 0 5px 5px 0;

                        .btn_box {
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            z-index: 9;
                            cursor: pointer;
                            display: flex;
                            .icon {
                                width: 35px;
                                height: 35px;
                                background: #fff;
                                border-radius: 50%;
                                line-height: 35px;
                                text-align: center;
                                margin-right: 5px;
                                border: 1px solid #fff;
                                i {
                                    font-size: 1.123rem;
                                }
                            }
                            .actived_icon {
                                color: #fff;
                                background-color: #66b1ff;
                            }
                        }
                        .img_box {
                            width: 300px;
                            height: 180px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .title {
                            line-height: 30px;
                            padding: 0 10px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .text {
                            font-size: 0.875rem;
                            color: #8d8d8d;
                            padding: 0 10px;
                            line-height: 30px;
                            height: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        .date {
                            font-size: 0.875rem;
                            color: #8d8d8d;
                            padding: 0 10px;
                            line-height: 30px;
                        }
                    }
                }
            }
        }
    }

</style>